(function () {
  'use strict';

  if (window.WagmadeContentPagesLoaded) return;
  window.WagmadeContentPagesLoaded = true;
  var contentPageSequence = 0;

  function createFaq(root) {
    var controller;
    var query = '';
    var category = 'all';
    var hasFiltered = false;

    function syncToc() {
      var toc = root.querySelector('[data-wm-faq-toc]');
      var list = toc && toc.querySelector('[data-wm-faq-toc-list]');
      if (!toc || !list) return;
      list.textContent = '';
      root.querySelectorAll('[data-wm-faq-item][id]').forEach(function (item) {
        var label = item.querySelector('summary > span:first-child');
        if (!label || !label.textContent.trim()) return;
        var link = document.createElement('a');
        link.href = '#' + item.id;
        link.textContent = label.textContent.trim();
        if (item.hidden) link.hidden = true;
        list.appendChild(link);
      });
      toc.hidden = list.childElementCount === 0;
    }

    function update(announceResults) {
      var visible = 0;
      root.querySelectorAll('[data-wm-faq-item]').forEach(function (item) {
        var matchesQuery = !query || (item.dataset.wmFaqIndex || '').includes(query);
        var matchesCategory = category === 'all' || item.dataset.wmFaqItemCategory === category;
        item.hidden = !(matchesQuery && matchesCategory);
        if (!item.hidden) visible += 1;
      });
      var empty = root.querySelector('[data-wm-faq-empty]');
      if (empty) empty.hidden = visible !== 0 || !hasFiltered;
      var results = root.querySelector('[data-wm-faq-results]');
      if (announceResults && results) {
        if (visible === 0) {
          results.textContent = results.dataset.wmFaqResultsEmpty || '';
        } else if (visible === 1) {
          results.textContent = results.dataset.wmFaqResultsSingular || '1 question found';
        } else {
          results.textContent = (results.dataset.wmFaqResultsPlural || '__COUNT__ questions found').replace('__COUNT__', String(visible));
        }
      }
      syncToc();
    }

    return {
      init: function () {
        controller = new AbortController();
        var signal = controller.signal;
        var search = root.querySelector('[data-wm-faq-search]');

        search?.addEventListener('input', function () {
          query = search.value.trim().toLowerCase();
          hasFiltered = true;
          update(true);
        }, { signal: signal });

        root.addEventListener('click', function (event) {
          var tocLink = event.target.closest('[data-wm-faq-toc] a[href^="#"]');
          if (tocLink && root.contains(tocLink)) {
            var target = document.getElementById(tocLink.getAttribute('href').slice(1));
            if (target && target.matches('details')) target.open = true;
            return;
          }
          var button = event.target.closest('[data-wm-faq-category]');
          if (!button || !root.contains(button)) return;
          category = button.dataset.wmFaqCategory;
          hasFiltered = true;
          root.querySelectorAll('[data-wm-faq-category]').forEach(function (item) {
            item.setAttribute('aria-pressed', String(item === button));
          });
          update(true);
        }, { signal: signal });

        update();
      },
      refresh: function () {
        this.destroy();
        this.init();
      },
      destroy: function () {
        if (controller) controller.abort();
        root.querySelectorAll('[data-wm-faq-item]').forEach(function (item) {
          item.hidden = false;
        });
        var empty = root.querySelector('[data-wm-faq-empty]');
        if (empty) empty.hidden = true;
      },
    };
  }

  function createContentPage(root) {
    var controller;
    var generatedHeadings = [];
    var sectionRoot = root.closest('.shopify-section');
    var idPrefix = (sectionRoot && sectionRoot.id) || root.id || root.getAttribute('aria-labelledby') || ('instance-' + (++contentPageSequence));

    function syncQuestionIndex() {
      var toc = root.querySelector('[data-wm-content-toc]');
      var list = toc && toc.querySelector('[data-wm-content-toc-list]');
      var content = root.querySelector('.wm-content-page__rte');
      var title = root.querySelector('.wm-content-page__header h1');
      if (!toc || !list || !content) return;

      list.textContent = '';
      var headingIndex = 0;
      content.querySelectorAll('h2, h3').forEach(function (heading) {
        var label = heading.textContent.trim();
        if (!label) return;
        if (title && label.toLowerCase() === title.textContent.trim().toLowerCase()) {
          heading.dataset.wmDuplicateTitle = 'true';
          return;
        }
        if (!heading.id) {
          heading.id = 'WmContentQuestion-' + idPrefix + '-' + headingIndex;
          heading.dataset.wmContentGeneratedId = 'true';
          generatedHeadings.push(heading);
        }
        headingIndex += 1;
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = label.replace(/^Q:\s*/i, '');
        list.appendChild(link);
      });
      toc.hidden = list.childElementCount === 0;
    }

    return {
      init: function () {
        controller = new AbortController();
        syncQuestionIndex();
      },
      refresh: function () {
        this.destroy();
        this.init();
      },
      destroy: function () {
        if (controller) controller.abort();
        generatedHeadings.forEach(function (heading) {
          heading.removeAttribute('id');
          heading.removeAttribute('data-wm-content-generated-id');
        });
        generatedHeadings = [];
        root.querySelectorAll('[data-wm-duplicate-title]').forEach(function (heading) {
          heading.removeAttribute('data-wm-duplicate-title');
        });
        var toc = root.querySelector('[data-wm-content-toc]');
        if (toc) toc.hidden = true;
      },
    };
  }

  function registerContentPages() {
    if (!window.WagmadeTheme) {
      runtimeAttempts += 1;
      if (runtimeAttempts <= 20) window.setTimeout(registerContentPages, 50);
      return;
    }
    window.WagmadeTheme.register('faq', '[data-wm-faq]', createFaq);
    window.WagmadeTheme.register('content-page', '[data-wm-content-page]', createContentPage);
    window.WagmadeTheme.init(document);
  }

  var runtimeAttempts = 0;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerContentPages, { once: true });
  } else {
    registerContentPages();
  }
})();
